<template>
    <div class="edit_wrap">
        <div class="pl10 pr10 mt20">
            <div class="pl10 mt20 mb20" v-if="infoData.schedule">
                <el-row>
                    <el-col :span="2">
                        <div class="grid-content">审核进展：</div>
                    </el-col>
                    <el-col :span="22"><div class="grid-content"><span class="main_word">{{ infoData.schedule.time*1000 | time }}&nbsp;&nbsp;{{ infoData.schedule.desc}}</span></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="22" :offset="2"><div class="grid-content" v-if="infoData.schedule.content">
                        ({{infoData.schedule.content}})</div></el-col>
                </el-row>
            </div>
            <p class="ml20">品牌品类基本信息</p>
            <div class="mt20 ml20">
                <el-form label-width="180px" class="demo-ruleForm">
                    <!-- 基础信息 -->
                    <el-form-item label="品牌品类编号：">
                        {{ infoData.brandAgreementCode }}
                    </el-form-item>
                    <el-form-item label="关联供应商合同编号：">
                        {{ infoData.contractCode }}
                    </el-form-item>
                    <el-form-item label="供应商编号：">
                        {{ infoData.supplierCode }}
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        {{ infoData.supplierName }}
                    </el-form-item>
                    <el-form-item label="合作方式：">
                        {{ infoData.cooperationTypeDesc }}
                    </el-form-item>
                    <el-form-item label="结算主体：">
                        <span v-if="infoData.settlementBodyId==1">北京果敢时代科技有限公司</span>
                        <span v-if="infoData.settlementBodyId==2">MAMA HONG KONG</span>
                        <span v-if="infoData.settlementBodyId==3">天津果敢时代国际贸易有限公司</span>
                        <span v-if="infoData.settlementBodyId==4">正合奇胜（天津）企业咨询管理有限公司</span>
                        <span v-if="infoData.settlementBodyId==5">老师线下打款</span>
                    </el-form-item>
                    <el-form-item label="合同有效期：">
                        {{ infoData.startTime | time }}至{{ infoData.endTime | time }}
                    </el-form-item>
                </el-form>
            </div>
            <p class="ml20">品牌品类信息</p>
            <div class="mt20 clearfix">
                <router-link v-if="infoData.status == 2" :to="'/add_brand_commonpages'+'?brandApplyId=0&brandAgreementId='+ id">
                    <el-button class="r mr10 mb10" type="primary">新增品牌</el-button>
                </router-link>
                <el-table :data="infoData.brandApplies" border style="width: 100%">
                    <el-table-column label="序号" width="74" align="center">
                        <template scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="brandName" label="品牌中文名称" min-width="80" align="center"></el-table-column>
                    <el-table-column prop="brandEnname" label="品牌英文名称" min-width="80" align="center"></el-table-column>
                    <el-table-column label="合作品类" min-width="120" align="center">
                        <template scope="scope">
                            <div class="bor_style" v-for="val in scope.row.categories">
                                {{ val.category.grandName }}-{{val.category.parentName}}-{{val.category.childrenName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" v-if="infoData.status == 2">
                        <template scope="scope">
                            <router-link :to="'/add_brand_commonpages'+'?brandApplyId=' + scope.row.brandApplyId + '&brandAgreementId='+ id + '&isType=' + (scope.row.brandId?1:2)">
                                <el-button type="text" size="small">编辑</el-button>
                            </router-link>
                            <el-button type="text" size="small" @click.native.prevent="handleDelete(scope.row.brandApplyId)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" v-if="infoData.status != 2">
                        <template scope="scope">
                            <router-link :to="'/common_detail'+'?brandApplyId=' + scope.row.brandApplyId + '&brandAgreementId='+ id">
                                <el-button type="text" size="small">查看</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="mt20 mb20" align="center" v-if="infoData.status == 1 || infoData.status == 3 || infoData.status == 5 || infoData.status == 7 || infoData.status == 9 || infoData.status == 11">
                    <el-button v-if="auth.edit" type="primary" @click="reback()">返回</el-button>
                    <el-button v-if="auth.edit" type="primary" @click="pushSupplier()">推送供应商</el-button>
                </div>
                <div class="mt20 mb20" align="center" v-if="infoData.status == 2">
                    <el-button v-if="auth.confirm" type="primary" @click="reback()">返回</el-button>
                    <el-button v-if="auth.confirm" type="primary" @click="rejectBtn()">驳回</el-button>
                    <el-button v-if="auth.confirm" type="primary" @click="pushSale()">推送采销</el-button>
                </div>
            </div>
            <!--预览图片弹框-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>

        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                dialogVisible: false,   // 预览弹框状态
                dialogImageUrl: '',     // 预览弹框url
                showReason:false,       // 驳回原因 是否展示状态
                // 驳回原因 内容
                scheduleObj:{
                    schedule:"",
                    content:""
                },
                auth: {
                    saleAudit: false,
                    inspectorAudit: false,
                    forensicAudit: false,
                    financeAudit: false,
                    push: false,
                    edit: false,
                    confirm: false
                },
                id: 0,
                infoData: {
                    // 品牌列表
                    brandApplies: [
                    ],

                },


            }
        },
        methods: {
            aaa (datas) {
              console.log(datas)
            },
            fetch () {
                var _this = this;
                $.get({
                    url: "/suppliers/agreementApply/brandAgreementApply/find",
                    data: {
                        id: _this.id
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.infoData = result.data;
                        }
                    }
                })
            },

            fetchAuth () {
                var _this = this;
                $.get({
                    url: "/suppliers/agreementApply/applyAuth/find",
                    data: {
                        agreementApplyId: _this.id
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
                            _this.auth = result.data;
                        }
                    }
                })
            },

            handleDelete (brandApplyId) {
                var _this = this;
                var id = parseInt(brandApplyId);
                $.ajax({
                    url: '/suppliers/agreementApply/brandApply/delete?brandApplyId=' + id,
                    contentType: 'application/json;charset=utf-8',
                    type: 'DELETE',
                    success: function (result) {
                        if (!result.code) {
                            _this.$message({
                                showClose: true,
                                message: '删除成功！',
                                type: 'success'
                            });
                            var brandList = _this.infoData.brandApplies;
                            var newBrandList = [];
                            for(var i = 0; i < brandList.length; i++) {
                                var brand = {};
                                brand = brandList[i];
                                if (brand.brandApplyId == id) {

                                } else {
                                    newBrandList.push(brand);
                                }
                                _this.infoData.brandApplies = newBrandList;
                            }
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            pushSupplier() {
                var _this = this;
                var Data = {};
                Data.agreementApplyId = this.id;
                Data.type = 2;
                Data.auditType = 1;
                Data.reason = '';
                $.ajax({
                    url: '/suppliers/agreementApply/audit/salePush',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            window.close();
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            pushSale() {
                var _this = this;
                if (this.infoData.brandApplies.length == 0) {
                    this.$message.error("请先添加品牌");
                    return;
                }
                var Data = {};
                Data.agreementApplyId = this.id;
                Data.type = 2;
                Data.auditType = 1;
                Data.reason = '';
                $.ajax({
                    url: '/suppliers/agreementApply/audit/supplierAudit',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            window.close();
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            rejectBtn () {
                this.$prompt('请输入驳回原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /.+/,
                    inputErrorMessage: '内容不能为空',
                    closeOnClickModal: false,
                    closeOnPressEscape: false
                }).then(({ value }) => {
                    this.rejectSale(value)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消驳回'
                    });
                });
            },
            rejectSale(reason) {
                var _this = this;
                var Data = {};
                Data.agreementApplyId = this.id;
                Data.type = 2;
                Data.auditType = 2;
                Data.reason = reason;
                $.ajax({
                    url: '/suppliers/agreementApply/audit/supplierAudit',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            window.close();
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 返回
            reback(){
                window.close();
            },

        },

        mounted () {
            this.$nextTick(function () {
                var id = this.$route.query.id;
                this.id = id;
                this.fetch();
                this.fetchAuth();
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
    }
    .bor_style:not(:last-child) {
        margin-left: -18px;
        margin-right: -18px;
        border-bottom: 1px solid #eadadd;
    }
</style>


// WEBPACK FOOTER //
// category_brand.vue?d29e880e